import { useTranslation } from 'react-i18next'
import type { DesignatedReviewView, LessonSelectionMeta } from '@/types/coaching'
import { LessonProgressDetailPane } from './LessonProgressDetailPane'
import { LessonRefreshButton } from './LessonRefreshButton'
import { ReviewReservationCard } from './ReviewChips'

interface Props {
  learnerId: number
  reservation: DesignatedReviewView
  selectionMeta: LessonSelectionMeta | null
  onCancelled: () => void
}

/** 콘텐츠 트리에서 선택한 복습 레슨의 예약 관리와 완료 내역을 제공하는 코칭 영역. */
export function DesignatedReviewCoachingDetail({ learnerId, reservation, selectionMeta, onCancelled }: Props) {
  const { t } = useTranslation('coaching')
  const completed = reservation.placementStatus === 'COMPLETED'

  return (
    <section aria-label={t('designatedReview.cards.detailTitle')} className="flex flex-col gap-3">
      <div className="rounded-lg border border-gray-200 bg-white p-4" data-testid="designated-review-detail">
        <header className="mb-4 flex flex-wrap items-start justify-between gap-3 border-b border-gray-100 pb-3">
          <div>
            <p className="text-xs font-semibold uppercase tracking-wide text-amber-700">
              {t('library.lessonReviewTag')}
            </p>
            <h2 className="mt-1 text-base font-semibold text-gray-950">
              {t('designatedReview.cards.detailTitle')}
            </h2>
          </div>
          {completed
            ? null
            : <LessonRefreshButton learnerId={learnerId} lessonId={reservation.reviewLessonId} />}
        </header>
        <ReviewReservationCard
          learnerId={learnerId}
          reservation={reservation}
          onCancelled={onCancelled}
          showActions
        />
      </div>
      {completed && (
        <LessonProgressDetailPane
          learnerId={learnerId}
          lessonId={reservation.reviewLessonId}
          selectionMeta={selectionMeta}
          attemptScope="review"
        />
      )}
    </section>
  )
}
